import PluginIframe from './PluginIframe';
import { PluginDefinition } from './types';

const LABEL = 'RightSideApp';

const RightSideApp = ({ pluginDefinition }: { pluginDefinition: PluginDefinition }): JSX.Element => {
    // useEffect(() => {
    //     console.warn(LABEL, 'mounting');

    //     return () => {
    //         console.warn(LABEL, 'unmounting');
    //     };
    // }, []);

    const pluginId = pluginDefinition.pluginId;

    return (
        <PluginIframe
            pluginId={pluginId}
            errorCallback={(status) => console.error(LABEL, `An error occurred in '${pluginId}': '${status}'.`)}
        />
    );
};

export default RightSideApp;
